<h2 mat-dialog-title mat-dialog-draggable-title>
  {{ "sign_processing_dialog.title" | translate }}
</h2>

<!-- VNeID: check selectedCert.typeCertificate trước, fallback sang selectedVNeIDCert.serialNumber -->
<div class="text-red-wrapper text-center mt-1 mb-2"
     *ngIf="dataDialog.selectedCert?.typeCertificate === 12 || dataDialog.selectedVNeIDCert?.serialNumber">
  <img class="sign-icon vneid" src="assets/images/vneid.png" alt="VNeID">
  <p class="text-red text-center mb-0 mt-2">{{ "sign_processing_dialog.vneid_message" | translate }}</p>
</div>

<!-- CloudCA MySign - hasTransSaved = false: check selectedCert.typeCertificate trước, fallback sang selectedCloudCaCert.serialNumber -->
<div class="text-red-wrapper text-center mt-1 mb-2"
     *ngIf="(dataDialog.selectedCert?.typeCertificate === 10 || dataDialog.selectedCloudCaCert?.serialNumber) && !dataDialog.selectedCert?.hasTransSaved">
  <img class="sign-icon" src="assets/images/mysign.png" alt="MySign">
  <p class="text-red text-center mb-0 mt-2">{{ "sign_processing_dialog.cloudca_mysign_message" | translate }}</p>
</div>

<!-- CloudCA MySign - hasTransSaved = true: check selectedCert.typeCertificate trước, fallback sang selectedCloudCaCert.serialNumber -->
<div class="text-red-wrapper text-center mt-1 mb-2"
     *ngIf="(dataDialog.selectedCert?.typeCertificate === 10 || dataDialog.selectedCloudCaCert?.serialNumber) && dataDialog.selectedCert?.hasTransSaved">
  <img class="sign-icon" src="assets/images/mysign.png" alt="MySign">
  <p class="text-red text-center mb-0 mt-2">{{ "sign_processing_dialog.cloudca_saved_session_message" | translate }}</p>
</div>

<mat-divider
  *ngIf="
    dataDialog.errorStatus || !dataDialog.signError || !dataDialog.isCancel
  "
></mat-divider>
<mat-progress-bar
  mode="indeterminate"
  *ngIf="
    !dataDialog.errorStatus && !dataDialog.signError && !dataDialog.isCancel
  "
></mat-progress-bar>
<mat-dialog-content>
  <div class="row px-1 py-1">
    <div class="col-12 pt-2">
      <p class="error-text mb-0" *ngIf="dataDialog.errorStatus">
        {{ dataDialog.errorStatus | translate }}
      </p>
      <div class="error-text mb-0" *ngIf="dataDialog.signError" [innerHTML]="dataDialog.signError">
      </div>
      <p
        class="error-text mb-0"
        *ngIf="dataDialog.errorStatus || dataDialog.signError"
      >
        {{ "sign_processing_dialog.note_close_dialog" | translate }}
      </p>
      <p class="text-right">
        {{ "sign_processing_dialog.sign" | translate }}
        {{ renderNumberProcessing() }}/{{ data.length }}
        file
      </p>
    </div>
    <div class="col-12">
      <mat-table [dataSource]="data" matSort>
        <!-- số thứ tự Column -->
        <ng-container matColumnDef="stt">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.index" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="text-center"
          >
            {{ i + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.name_file_page_sign" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ renderNameFile(element.fileId) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.status" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="text-center">
            <mat-icon style="color: #07736c" *ngIf="element.done">
              done
            </mat-icon>
            <mat-icon *ngIf="!element.done &&
                (dataDialog.errorStatus ||
                  dataDialog.signError ||
                  dataDialog.isCancel || cancelFlow)" style="color: red;">close</mat-icon>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
        </mat-row>
      </mat-table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mt-2">
  <!-- *ngIf="!dataDialog.errorStatus && !dataDialog.signError" -->
  <button
    mat-stroked-button
    color="primary"
    class="mr-3"
    type="button"
    *ngIf="false"
    [disabled]="dataDialog.isCallDone || dataDialog.isCancel"
    (click)="dataDialog.signCancel()"
  >
    <mat-icon class="mr-0">cancel</mat-icon
    >{{ "sign_processing_dialog.stop_signing" | translate }}
  </button>
  <button
    (click)="dataDialog.signClose()"
    mat-stroked-button
    color="primary"
    class="mr-3"
    type="button"
    *ngIf="dataDialog.errorStatus || dataDialog.signError"
    mat-dialog-close
  >
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
</mat-dialog-actions>
